import { useEffect, useState } from "react";
import { DeviceMobile, X } from "@phosphor-icons/react";

/**
 * Listens for beforeinstallprompt (Chrome / Edge / Android),
 * and shows a discreet install banner the user can dismiss.
 * Saves dismissal in localStorage so we don't nag.
 */
export default function PWAInstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    let dismissed = false;
    try { dismissed = !!localStorage.getItem("lazylean_pwa_dismissed"); } catch { /* ignore */ }
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setHidden(false);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (hidden || !prompt) return null;

  const install = async () => {
    try {
      await prompt.prompt();
      await prompt.userChoice;
    } catch { /* user cancelled */ }
    setHidden(true);
    setPrompt(null);
    try { localStorage.setItem("lazylean_pwa_dismissed", "1"); } catch { /* ignore */ }
  };

  const dismiss = () => {
    setHidden(true);
    try { localStorage.setItem("lazylean_pwa_dismissed", "1"); } catch { /* ignore */ }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:bottom-4 md:max-w-sm bg-[#0F0F0F] border border-[#FF3333] shadow-2xl z-50 p-4" data-testid="pwa-install-banner">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-[#FF3333] flex items-center justify-center shrink-0">
          <DeviceMobile size={20} weight="bold" color="#fff" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-oswald text-base uppercase tracking-wide text-white">Install Lazy Lean</div>
          <p className="text-zinc-400 text-xs font-manrope mt-0.5 leading-snug">
            One tap, no app store. Habit check-ins on your home screen.
          </p>
          <div className="flex gap-2 mt-3">
            <button onClick={install} className="id-btn-primary text-xs px-4 py-2" data-testid="pwa-install-button">Install</button>
            <button onClick={dismiss} className="text-zinc-500 hover:text-white text-xs uppercase tracking-[0.15em] px-2" data-testid="pwa-dismiss-button">Not now</button>
          </div>
        </div>
        <button onClick={dismiss} className="text-zinc-600 hover:text-white shrink-0">
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
